/*
 * Copyright (c) 2024 GM Global Technology Operations LLC. All rights reserved.
 * This information is confidential and proprietary to GM Global Technology
 * Operations LLC and may not be used, modified, copied or distributed.
 */

import {APP_INITIALIZER, NgModule, CUSTOM_ELEMENTS_SCHEMA} from '@angular/core';
import { CommonModule } from '@angular/common';
import {HttpClientModule} from "@angular/common/http";
import {AuthenticationService} from '../core/auth/authentication.service';
import {AppLoadService} from "../services/app-load.service";
import { NgxSpinnerModule } from 'ngx-spinner';



export function get_userInfo(appLoadService: AppLoadService, authService: AuthenticationService){
  return () => appLoadService.getUserInfo();

}

@NgModule({
  imports: [
    CommonModule, HttpClientModule, NgxSpinnerModule
  ],
  providers: [
    AppLoadService,
    { provide: APP_INITIALIZER, useFactory: () => {
        return get_userInfo;
      }, deps: [AppLoadService], multi: true }
  ],
  declarations: [],
  schemas:[CUSTOM_ELEMENTS_SCHEMA]
})
export class AppLoadModule { }
